import { z } from "zod";
export const reportMetadataUpdateSchema = z.object({
    reportId: z.string(),
    metadata: z.string().nullable(),
});
export const bulkReportMetadataUpdateSchema = z.object({
    updates: z.array(reportMetadataUpdateSchema),
});
//# sourceMappingURL=report.model.js.map